// LLM generated - Model Claude 4 Sonnet
type IconRocketAuroraProps = {
  size?: number;
  strokeWidth?: number;
};

export default function IconRocketAurora({ size = 28, strokeWidth = 2.5 }: IconRocketAuroraProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.16664 16.3334C6.95241 17.0189 5.97057 18.0514 5.34699 19.2985C4.72341 20.5457 4.4865 21.9507 4.66664 23.3334C6.04932 23.5135 7.4543 23.2766 8.70146 22.653C9.94863 22.0294 10.9811 21.0476 11.6666 19.8334M4.66665 15.1667C6.74692 15.4139 8.68354 16.3538 10.1649 17.8351C11.6462 19.3165 12.5861 21.2531 12.8333 23.3334C13.8646 22.7388 14.7272 21.8912 15.3396 20.8704C15.952 19.8497 16.294 18.6897 16.3333 17.5C18.2923 16.8109 20.0029 15.5563 21.2489 13.895C22.4949 12.2337 23.2203 10.2402 23.3333 8.16669C23.3333 7.23843 22.9646 6.34819 22.3082 5.69181C21.6518 5.03544 20.7616 4.66669 19.8333 4.66669C17.7598 4.77975 15.7663 5.50513 14.105 6.75111C12.4437 7.9971 11.1891 9.70773 10.5 11.6667C9.31029 11.706 8.15026 12.048 7.12955 12.6604C6.10884 13.2728 5.26117 14.1354 4.66665 15.1667ZM18.6666 10.5C18.6666 11.1444 18.1443 11.6667 17.5 11.6667C16.8556 11.6667 16.3333 11.1444 16.3333 10.5C16.3333 9.85569 16.8556 9.33335 17.5 9.33335C18.1443 9.33335 18.6666 9.85569 18.6666 10.5Z"
        stroke="url(#paint0_linear_rocket_aurora)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_rocket_aurora"
          x1="4.60797"
          y1="14.0294"
          x2="23.3333"
          y2="14.0294"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BC4CF" />
          <stop offset="1" stopColor="#7F1A93" />
        </linearGradient>
      </defs>
    </svg>
  );
}

IconRocketAurora.displayName = 'IconRocketAurora';
